import { render, staticRenderFns } from "./testPaper.vue?vue&type=template&id=7b665a5a&"
import script from "./testPaper.vue?vue&type=script&lang=js&"
export * from "./testPaper.vue?vue&type=script&lang=js&"
import style0 from "./testPaper.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports